import { initialTotSelectState, TotSelectState } from '../state/totselect.state';
import { TotSelectActions, ETotSelectActions } from '../actions/totselect.actions';
import { Scommessa } from 'src/app/models/totselect.interface';

enum SCOMMESSA {
  'VIN' = 1,
  'PIA2' = 2,
  'PIA3' = 3,
  'PIA4' = 4,
  'PIA5' = 5,
  'PIA6' = 6,
  'ACC' = 7,
  'ACCO' = 8,
  'TRIOD' = 9,
  'TRIO' = 10,
  'QUAD' = 11,
  'QUA' = 12,
  'QUID' = 13,
  'QUI' = 14,
  'SESD' = 15,
  'SES' = 16,
  'ACP' = 17,
}

enum DESCSCOMMESSA {
  'Vincente' = 1,
  'Piazzato su 2' = 2,
  'Piazzato su 3' = 3,
  'Piazzato su 4' = 4,
  'Piazzato su 5' = 5,
  'Piazzato su 6' = 6,
  'Accoppiata' = 7,
  'Accoppiata in ordine' = 8,
  'Trio' = 9,
  'Tris' = 10,
  'Quartè in disordine' = 11,
  'Quartè' = 12,
  'Quintè in disordine' = 13,
  'Quintè' = 14,
  'Sestè' = 15,
  'Sestè in ordine' = 15,
  'Accoppiata piazzata' = 17,
}

export const totSelectReducers = (
  state = initialTotSelectState,
  action: TotSelectActions
): TotSelectState => {
  switch (action.type) {
    case ETotSelectActions.AddTotSelect: {
      return {
        ...state,
        totSelect: {
          ...state.totSelect,
          maps: [
            action.payload.position === 1 && !state.totSelect.maps[0].includes(action.payload.esito)
              ? [...state.totSelect.maps[0], action.payload.esito]
              : state.totSelect.maps[0],

            action.payload.position === 2 && !state.totSelect.maps[1].includes(action.payload.esito)
              ? [...state.totSelect.maps[1], action.payload.esito]
              : state.totSelect.maps[1],

            action.payload.position === 3 && !state.totSelect.maps[2].includes(action.payload.esito)
              ? [...state.totSelect.maps[2], action.payload.esito]
              : state.totSelect.maps[2],

            action.payload.position === 4 && !state.totSelect.maps[3].includes(action.payload.esito)
              ? [...state.totSelect.maps[3], action.payload.esito]
              : state.totSelect.maps[3],

            action.payload.position === 5 && !state.totSelect.maps[4].includes(action.payload.esito)
              ? [...state.totSelect.maps[4], action.payload.esito]
              : state.totSelect.maps[4],

            action.payload.position === 6 && !state.totSelect.maps[5].includes(action.payload.esito)
              ? [...state.totSelect.maps[5], action.payload.esito]
              : state.totSelect.maps[5],
          ],
        },
      };
    }

    case ETotSelectActions.UpdateTotCombination: {
      let totalTicket = 0;
      totalTicket =
        totalTicket +
        (state.totSelect.scoTot.length > 0
          ? state.totSelect.scoTot.map((item) => item.imp).reduce((prev, next) => prev + next)
          : 0);
      totalTicket =
        totalTicket +
        (state.totSelect.scoPsr.length > 0
          ? state.totSelect.scoPsr.map((item) => item.imp).reduce((prev, next) => prev + next)
          : 0);
      totalTicket =
        totalTicket +
        (state.totSelect.scoSel
          ? action.payload * state.totSelect.multi * state.totSelect.scoSel.base
          : action.payload * state.totSelect.multi);
      return {
        ...state,
        totSelect: {
          ...state.totSelect,
          totalTicket: totalTicket,
          combinazioni: action.payload,
          total: state.totSelect.scoSel
            ? action.payload * state.totSelect.multi * state.totSelect.scoSel.base
            : action.payload * state.totSelect.multi,
        },
      };
    }

    case ETotSelectActions.UpdateMulti: {
      let totalTicket = 0;
      totalTicket =
        totalTicket +
        (state.totSelect.scoTot.length > 0
          ? state.totSelect.scoTot.map((item) => item.imp).reduce((prev, next) => prev + next)
          : 0);
      totalTicket =
        totalTicket +
        (state.totSelect.scoPsr.length > 0
          ? state.totSelect.scoPsr.map((item) => item.imp).reduce((prev, next) => prev + next)
          : 0);
      totalTicket =
        totalTicket +
        (state.totSelect.scoSel
          ? action.payload * state.totSelect.combinazioni * state.totSelect.scoSel.base
          : action.payload * state.totSelect.combinazioni);
      return {
        ...state,
        totSelect: {
          ...state.totSelect,
          totalTicket: totalTicket,
          multi: action.payload,
          total: state.totSelect.scoSel
            ? action.payload * state.totSelect.combinazioni * state.totSelect.scoSel.base
            : action.payload * state.totSelect.combinazioni,
        },
      };
    }

    case ETotSelectActions.Add: {
      return {
        ...state,
        totSelect: {
        ...state.totSelect,
         state: action.payload.state
        }
      };
    }

    case ETotSelectActions.ResetTotSystem: {
      return {
        ...state,
        totSelect: {
          ...state.totSelect,
          total: 0,
          combinazioni: 0,
          sisSel: null,
        },
      };
    }

    case ETotSelectActions.ResetTotSco: {
      return {
        ...state,
        totSelect: {
          ...state.totSelect,
          scoSel: null,
        },
      };
    }

    case ETotSelectActions.AddSessionTot: {
      return {
        ...state,
        totSelect: {
          ...state.totSelect,
          session: action.payload,
        },
      };
    }

    case ETotSelectActions.SelectSco: {
      return {
        ...state,
        totSelect: {
          ...state.totSelect,
          scoSel: action.payload,
        },
      };
    }

    case ETotSelectActions.SelectSystem: {
      return {
        ...state,
        totSelect: {
          ...state.totSelect,
          sisSel: action.payload,
        },
      };
    }

    case ETotSelectActions.DelTotSelect: {
      return {
        ...state,
        totSelect: {
          ...state.totSelect,
          maps: [
            action.payload.position === 1
              ? state.totSelect.maps[0].filter((x) => x !== action.payload.esito)
              : state.totSelect.maps[0],
            action.payload.position === 2
              ? state.totSelect.maps[1].filter((x) => x !== action.payload.esito)
              : state.totSelect.maps[1],
            action.payload.position === 3
              ? state.totSelect.maps[2].filter((x) => x !== action.payload.esito)
              : state.totSelect.maps[2],
            action.payload.position === 4
              ? state.totSelect.maps[3].filter((x) => x !== action.payload.esito)
              : state.totSelect.maps[3],
            action.payload.position === 5
              ? state.totSelect.maps[4].filter((x) => x !== action.payload.esito)
              : state.totSelect.maps[4],
            action.payload.position === 6
              ? state.totSelect.maps[5].filter((x) => x !== action.payload.esito)
              : state.totSelect.maps[5],
          ],
        },
      };
    }

    case ETotSelectActions.ResetMapsTotSelect: {
      return {
        ...state,
        totSelect: {
          ...state.totSelect,
          maps: [[], [], [], [], [], []],
        },
      };
    }

    case ETotSelectActions.InitTotSelect: {
      const scom: Array<Scommessa> = [];

      action.payload.scommesse
        // .filter((x) => x.t === action.payload.scommesse.filter((y) => y.s === 1)[0].t)
        .forEach((element) => {
          let pos = 0;
          let ord = false;

          switch (element.s) {
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
              pos = 1;
              break;
            case 7:
            case 8:
            case 17:
              pos = 2;
              break;
            case 9:
            case 10:
              pos = 3;
              break;
            case 11:
            case 12:
              pos = 4;
              break;
            case 13:
            case 14:
              pos = 5;
              break;
            case 15:
            case 16:
              pos = 6;
              break;
            default:
              break;
          }

          switch (element.s) {
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 9:
            case 11:
            case 13:
            case 15:
            case 17:
              ord = false;
              break;
            case 8:
            case 10:
            case 12:
            case 14:
            case 16:
              ord = true;
              break;
            default:
              break;
          }

          const obj: Scommessa = {
            text: element.t === 'PSR' && element.s === 10 ? 'TRIS' : SCOMMESSA[element.s],
            command: 'select' + SCOMMESSA[element.s],
            value: element.s,
            desc: element.t === 'TOT' && element.s === 10 ? 'Trio' : DESCSCOMMESSA[element.s],
            posizione: pos,
            ordine: ord,
            disabled: false,
            base: element.b,
            stato: element.st,
            tipo: element.t,
            mincomb: element.m,
          };

          scom.push(obj);
        });

      return {
        ...state,
        totSelect: {
          ...state.totSelect,
          pal: action.payload.pal,
          avv: action.payload.avv,
          palPsr: action.payload.palPsr,
          concPsr: action.payload.concPsr,
          tcPsr: action.payload.tcPsr,
          race: action.payload.race,
          scommesse: scom,
          maps: [[], [], [], [], [], []],
          scoTot: [],
          scoPsr: [],
          totalTicket: 0,
          state: { esi: 0, idTicket: '', description: '' },
          total: 0,
          multi: 1,
          combinazioni: 0,
          scoSel: null,
          sisSel: null,
        },
      };
    }

    case ETotSelectActions.AddScoTot: {
      const array = [];
      for (let _i = 0; _i < state.totSelect.sisSel.map; _i++) {
        array[_i] = { esi: state.totSelect.maps[_i] };
      }
      return {
        ...state,
        totSelect: {
          ...state.totSelect,
          scoTot: [
            ...state.totSelect.scoTot,
            {
              cod: state.totSelect.scoSel.value.toString(),
              sis: state.totSelect.sisSel.value.toString(),
              mol: state.totSelect.multi.toString(),
              imp: state.totSelect.total,
              map: array,
            },
          ],
          state: { esi: 0, idTicket: '', description: '' },
        },
      };
    }

    case ETotSelectActions.RemoveScoTot: {
      const index = action.payload;
      const amount = state.totSelect.totalTicket - state.totSelect.scoTot[index].imp;
      return {
        ...state,
        totSelect: {
          ...state.totSelect,
          totalTicket: amount,
          scoTot: [
            ...state.totSelect.scoTot.slice(0, index),
            ...state.totSelect.scoTot.slice(index + 1),
          ],
          state: { esi: 0, idTicket: '', description: '' },
        },
      };
    }

    case ETotSelectActions.AddScoPsr: {
      const array = [];
      for (let _i = 0; _i < state.totSelect.sisSel.map; _i++) {
        array[_i] = { esi: state.totSelect.maps[_i] };
      }
      return {
        ...state,
        totSelect: {
          ...state.totSelect,
          scoPsr: [
            ...state.totSelect.scoPsr,
            {
              uni: state.totSelect.combinazioni,
              mol: state.totSelect.multi.toString(),
              imp: state.totSelect.total,
              gru: [
                {
                  cod: 1,
                  eve: [
                    {
                      cod: state.totSelect.concPsr,
                      sco: state.totSelect.scoSel.value.toString(),
                      sis: state.totSelect.sisSel.value.toString(),
                      map: array,
                    },
                  ],
                },
              ],
            },
          ],
          state: { esi: 0, idTicket: '', description: '' },
        },
      };
    }

    case ETotSelectActions.RemoveScoPsr: {
      const index = action.payload;
      const amount = state.totSelect.totalTicket - state.totSelect.scoPsr[index].imp;
      return {
        ...state,
        totSelect: {
          ...state.totSelect,
          totalTicket: amount,
          scoPsr: [
            ...state.totSelect.scoPsr.slice(0, index),
            ...state.totSelect.scoPsr.slice(index + 1),
          ],
          state: { esi: 0, idTicket: '', description: '' },
        },
      };
    }

    case ETotSelectActions.ResetScoTotPsr: {
      return {
        ...state,
        totSelect: {
          ...state.totSelect,
          scoTot: [],
          scoPsr: [],
          totalTicket: 0,
          state: { esi: 0, idTicket: '', description: '' },
          total: 0,
          multi: 1,
          combinazioni: 0,
          scoSel: null,
          sisSel: null,
        },
      };
    }

    case ETotSelectActions.UpdateScoTotQuick: {
      return {
        ...state,
        totSelect: {
          ...state.totSelect,
          stateQuick: action.payload,
        },
      };
    }

    default:
      return state;
  }
};
